class scrollDown extends HTMLElement {

  constructor() {
    super();
    
    this.nextSection = this.closest('.shopify-section').nextElementSibling;
    this.openCollapsible = false;
    if (this.dataset && this.dataset.openCollapsible) {
      this.openCollapsible = this.dataset.openCollapsible;
    }
    
    if (this.nextSection) {
      this.classList.remove('hidden');
      this.addEventListener('click', this.onClick);
    }
  }

  onClick() {
    this.nextSection.scrollIntoView({behavior: "smooth", block: "center"});
    if (this.openCollapsible) {
      this.nextSection.querySelectorAll('[data-collapsible-group]')[0].classList.add('collapsible-is-open');
    }
  }
}

if (!customElements.get('scroll-down')) {
  customElements.define('scroll-down', scrollDown);
}